import React from 'react';
import { Heading, PropertyGroup } from '../../components';

import css from './ListingPage.module.css';

const customHeadings = {
  "proofOfLife": "Team Parnexus has seen the following proof:",
  "buyerProof": "Team Parnexus has seen the following proof:",
};

const SectionMultiEnumMaybe = props => {
  const { fieldKey, heading, options, selectedOptions, showAsCommaSeparated } = props;

  if (!heading || !options || !selectedOptions || selectedOptions?.length == 0) {
    return null;
  };

  const finalHeading = customHeadings[fieldKey] || heading;

  return (
    <section className={css.sectionMultiEnum}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {finalHeading}
      </Heading>
      <PropertyGroup
        id="ListingPage.amenities"
        options={options}
        selectedOptions={selectedOptions}
        twoColumns={options.length > 5}
        showAsCommaSeparated={showAsCommaSeparated}
      />
    </section>
  );
};

export default SectionMultiEnumMaybe;
